import { render } from "./AirCNavBarItem.vue?vue&type=template&id=028374a2&scoped=true"
import script from "./AirCNavBarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AirCNavBarItem.vue?vue&type=script&setup=true&lang=js"

import "./AirCNavBarItem.vue?vue&type=style&index=0&id=028374a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028374a2"],['__file',"src/components/AirCNavBar/AirCNavBarItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "028374a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('028374a2', __exports__)) {
    api.reload('028374a2', __exports__)
  }
  
  module.hot.accept("./AirCNavBarItem.vue?vue&type=template&id=028374a2&scoped=true", () => {
    api.rerender('028374a2', render)
  })

}


export default __exports__